exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'team') return `/team/${doc.uid}/`
  if (doc.type === 'blogpost') return `/blog/${doc.uid}/`
  if (doc.type === 'member_page') return `/account/${doc.uid !== 'members' ? doc.uid : ''}/`
  return '/'
}
